import React from 'react';
import { usePortalStore } from '../store';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = usePortalStore();

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-20 right-4 z-[9999] flex flex-col gap-2 pointer-events-none"
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-xl pointer-events-auto
            max-w-sm text-sm font-medium border
            ${toast.type === 'success' ? 'bg-emerald-950 border-emerald-700 text-emerald-100' :
              toast.type === 'error'   ? 'bg-red-950 border-red-700 text-red-100' :
                                         'bg-slate-800 border-slate-600 text-slate-100'}
          `}
        >
          {toast.type === 'success' && <CheckCircle className="w-4 h-4 text-emerald-400 shrink-0" />}
          {toast.type === 'error'   && <XCircle     className="w-4 h-4 text-red-400 shrink-0" />}
          {toast.type === 'info'    && <Info         className="w-4 h-4 text-cyan-400 shrink-0" />}
          <span className="flex-1">{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
            aria-label="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
};
